<div class="tabs-container vertical">
  <ul class="nav nav-tabs right-only-box-shadow">
    @for (tab of tabs; track tab; let i = $index) {
    <li
      class="tab"
      [ngClass]="{ active: tab.active === true }"
      (click)="selectTab(tab)"
    >
      @switch (i) { @case (0) {
      <a class="has-tooltip-right" data-tooltip="History" placement="right">
        <i class="fa fa-history" aria-hidden="true"></i
      ></a>
      } @case (1) {
      <a class="has-tooltip-right" data-tooltip="Pin" placement="right">
        <i class="fa fa-thumb-tack" aria-hidden="true"></i
      ></a>
      } @case (2) {
      <a
        class="has-tooltip-right"
        data-tooltip="Generate Docment"
        placement="right"
        ><i class="fa fa-file-text-o" aria-hidden="true"></i
      ></a>
      } @case (3) {
      <a class="has-tooltip-right" data-tooltip="Audio" placement="right">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>
        <!-- <i class="fa fa-file-video-o" aria-hidden="true"></i> -->
      </a>
      } @case (4) {
      <a class="has-tooltip-right" data-tooltip="Template" placement="right">
        <i class="fa fa-magic" aria-hidden="true"></i>
      </a>
      } }
    </li>
    }
  </ul>
  <div class="tab-content" [ngClass]="{ active: showTabConent }">
    <ng-content></ng-content>
  </div>
  <!-- <ng-container *ngIf="showTabConent">
  <div style="position: sticky;z-index:999;width:30px;height:30px;background:#fff;" (click)="expandPanel()">
    <a > <i class="fa" [ngClass]="showTabConent ? 'fa-chevron-left' : 'fa-chevron-right'" aria-hidden="true"></i></a>
  </div>
</ng-container> -->
</div>
